/**************************************************
 * Nombre:       Formulario_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {
    AccountCircleOutlined,
    Flag,
    FlagOutlined,
    GeneratingTokensOutlined,
    Google,
    PhoneAndroid,
    Title
} from "@mui/icons-material";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {CRYPTOS, ESTADOSSOPORTE} from "../../Constantes";
import {QRCodeSVG} from 'qrcode.react';
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import {copiarPortapapeles} from "../../CodigoCliente/Funciones/copiarPortapapeles";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";

const Formulario_Perfil = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <IngresoImagenCrop dato={'img'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                        requerido={'El nombre es requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Google} nombre={'Correo'} dato={'correo'} {...props}
                        editable={false}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                  opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={PhoneAndroid} nombre={'Celular'} dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={2} nombre={'Direccion de Billetera LTC RED (LITECOIN)'} dato={'billetera'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Perfil